"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import {
    LayoutDashboard,
    Package,
    Users,
    Settings,
    Store,
    Receipt,
    BarChart3,
    LogOut,
    Leaf
} from "lucide-react";

export const Sidebar = () => {
    const pathname = usePathname();

    const navItems = [
        { href: "/", label: "Overview", icon: LayoutDashboard },
        { href: "/inventory", label: "Inventory", icon: Package },
        { href: "/farmers", label: "Farmers", icon: Users },
        { href: "/dashboard", label: "Dashboard", icon: Settings },
        { href: "/vendors", label: "Vendors", icon: Store },
        { href: "/expenses", label: "Expenses", icon: Receipt },
        { href: "/reports", label: "Reports", icon: BarChart3 },
    ];

    return (
        <aside className="sidebar">
            <div className="sidebar-brand">
                <h2>Agrimart</h2>
            </div>
            <nav className="sidebar-nav">
                {navItems.map((item) => {
                    const Icon = item.icon;
                    const isActive = pathname === item.href;
                    return (
                        <Link
                            key={item.href}
                            href={item.href}
                            className={`nav-item ${isActive ? "active" : ""}`}
                        >
                            <Icon size={20} />
                            {item.label}
                        </Link>
                    );
                })}
            </nav>
            <div className="sidebar-footer">
                <Link href="/api/auth/signout" className="nav-item logout">
                    <LogOut size={20} />
                    Logout
                </Link>
            </div>
        </aside>
    );
};
